import styled, { css } from "styled-components/native";
// import { getBottomSpacing } from "../../utils/functions";

interface ContentButtonProps {
  align: "flex-start" | "center" | "flex-end";
}

export const Container = styled.View<ContentButtonProps>`
  width: 100%;
  padding: 16px 16px 0 16px;
  ${(props) =>
    props.align === "center"
      ? css`
          align-self: center;
        `
      : css`
          align-items: ${props.align};
        `};
  bottom: 10px;
`;
